import { render } from "./IrbApplicationsUExp.vue?vue&type=template&id=7ff8b5f6&ts=true"
import script from "./IrbApplicationsUExp.vue?vue&type=script&lang=ts"
export * from "./IrbApplicationsUExp.vue?vue&type=script&lang=ts"

import "./IrbApplicationsUExp.vue?vue&type=style&index=0&id=7ff8b5f6&lang=scss"

import exportComponent from "/home/meiyeer/irb-app-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__